import React, { useEffect, useState } from "react"
import { Switch, Route, Redirect, useLocation } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"

import { focusHandling } from "cruip-js-toolkit"
import "./charts/ChartjsConfig"

// Import pages
import Login from './pages/Login'
import Orders from './pages/Orders'

// Import partial components
import Header from './partials/Header'
import Receive from './components/resusable/receive'
import LockSession from "./components/modals/lockSession"

import { usePet } from "./modules"

import { setparams, setuser } from "./store/actions"

import './css/style.scss'
import './App.css'

const Main = () => {
    const [lock, setLock] = useState(false)
    const [sidebarOpen, setSidebarOpen] = useState(false)

    const { params, user } = useSelector(state => state.application)
    const dispatch = useDispatch()

    let timer

    const lockSession = () => {
        clearTimeout(timer)
        
        document.onmousemove = null
        document.onkeydown = null

        sessionStorage.removeItem('token')
        setLock(true)
    }

    const resetTimer = () => {
        setLock(false)
        clearTimeout(timer)
        timer = setTimeout(lockSession, (params?.timeOut ? params.timeOut : 20) * 60000)
        
        document.onmousemove = resetTimer

        document.onkeydown = e => {
            if (e.altKey && e.key === 'L') {
                lockSession()
            } else {
                resetTimer()
            }
        }
    }

    const onComplete = ({ data }) => {
        dispatch(setuser(data))
        // resetTimer()
    }

    const [{ loading, error }] = usePet('me', {}, { notify: true, callback: onComplete, logOutOnError: true })

    usePet('itemGroups', {}, { notify: true, callback: ({ data }) => {
        for (let group of data)
            if (group.printer)
                localStorage.setItem(group.name, group.printer.name)
    }, logOutOnError: true })

    return (
        <Receive
            error={error}
            loading={loading}
            progress>
            {/* <div className="flex h-screen overflow-hidden">
                <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} /> */}
                <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden">
                    <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
                    <main className="px-16">
                        <Switch>
                            {/* <Route exact path="/app">
                                <Dashboard />
                            </Route> */}
                            <Route path="/app/bills">
                                <Orders />
                            </Route>
                            {/* <Route exact path="/app/bills/new">
                                <NewOrder />
                            </Route>
                            <Route exact path="/app/bills/add/:id">
                                <AddToBill />
                            </Route> */}
                            {/* <Route exact path="/app/stations">
                                <Stations />
                            </Route>
                            <Route exact path="/app/stations/:id">
                                <Station />
                            </Route>
                            <Route exact path="/app/users">
                                <Users />
                            </Route>
                            <Route exact path="/app/sales/:category">
                                <SalesByItem />
                            </Route>
                            <Route exact path="/app/inventory">
                                <Inventory />
                            </Route>
                            <Route exact path="/app/requests">
                                <Requests />
                            </Route>
                            <Route exact path='/app/inventory/:id/history'>
                                <ItemTimeline />
                            </Route> */}
                        </Switch>
                    </main>
                </div>
            {/* </div> */}
            {
                lock &&
                <LockSession
                    onPerform={ resetTimer }
                    visible={ lock } />
            }
        </Receive>
    )
}

const App = () => {
    const location = useLocation()

    const { loggedIn } = useSelector(state => state.application)
    const dispatch = useDispatch()

    const [{ loading, error }] = usePet('params', {}, { notify: true, callback: ({ data }) => {
        if (data?.name) {
            document.title = `Hisani for ${data?.name}`
            dispatch(setparams(data))
        }
    }, logOutOnError: true })

    useEffect(() => {
        document.querySelector('html').style.scrollBehavior = 'auto'
        window.scroll({ top: 0 })
        document.querySelector('html').style.scrollBehavior = ''
        focusHandling('outline')
    }, [location.pathname])

    return (
        <Switch>
            <Route exact path="/">
                <Redirect to="/login" />
            </Route>
            <Route path="/login">
                <Login />
            </Route>
            <Route path="/app">
                {
                    loggedIn ?
                        <Main />
                    : <Redirect to="/login" />
                }
            </Route>
        </Switch>
    )
}

export default App
